import { render, staticRenderFns } from "./EmployeeAnnounceCMP.vue?vue&type=template&id=070a4ca4&scoped=true&"
import script from "./EmployeeAnnounceCMP.vue?vue&type=script&lang=js&"
export * from "./EmployeeAnnounceCMP.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAnnounceCMP.vue?vue&type=style&index=0&id=070a4ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070a4ca4",
  null
  
)

export default component.exports